import PropTypes from "prop-types";
import React from "react";

import formatPrice from "../lib/TradingView/formatPrice";

class Price extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currency: PropTypes.string,
    roundToSecondNumber: PropTypes.bool,
    useCommaAsDecimalPointer: PropTypes.bool,
    maxDecimalPlace: PropTypes.number
  };

  static defaultProps = {
    roundToSecondNumber: false,
    useCommaAsDecimalPointer: false,
    maxDecimalPlace: 4
  };

  static stripTrailingZeros(number) {
    return Number(number).toString();
  }

  render() {
    const {
      value,
      currency,
      roundToSecondNumber,
      useCommaAsDecimalPointer,
      maxDecimalPlace
    } = this.props;

    return formatPrice({
      value,
      currency,
      roundToSecondNumber,
      useCommaAsDecimalPointer,
      maxDecimalPlace
    });
  }
}

export default Price;
